import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { getDataTestId } from '@/js/libs/utils/get-data-test-id';
import { HoverableWarningIcon } from './HoverableWarningIcon';
import { Number, Wrapper } from './styled';
export const Item = memo(function Item({ id, index, title, active, error, setActiveId, dataTestId }) {
    const testId = useMemo(() => getDataTestId(dataTestId, active ? 'active' : 'inactive'), [active, dataTestId]);
    const handleClick = useCallbackRef(() => {
        setActiveId(id);
    });
    return (_jsxs(Wrapper, { active: active, error: error ?? false, onClick: handleClick, "data-testid": testId, children: [_jsx(Number, { active: active, children: index + 1 }), title, error && _jsx(HoverableWarningIcon, {})] }));
});
